import React from "react";
import { FaClipboardList, FaHandshake, FaShieldAlt } from "react-icons/fa";
import mechImg from "../assets/diagnosis1.png";

const principles = [
  {
    title: "Verified capacity",
    text: "Garages and roadside teams need clear standards before they receive driver jobs.",
    icon: FaShieldAlt,
  },
  {
    title: "Transparent handoffs",
    text: "Drivers should know who is taking the job, what is being checked, and when approval is needed.",
    icon: FaHandshake,
  },
  {
    title: "Useful records",
    text: "Each service should leave a vehicle history trail that helps the next repair decision.",
    icon: FaClipboardList,
  },
];

export default function OurMission() {
  return (
    <div className="bg-[#F7F8EF] py-24 text-[#111714]">
      <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-12">
        <div className="grid items-end gap-10 border-b border-[#CFDBC8] pb-12 lg:grid-cols-[0.95fr_1fr]">
          <div>
            <p className="mb-4 inline-flex rounded-full bg-[#E2F2D7] px-4 py-2 text-xs font-black uppercase tracking-[0.18em] text-[#2D5B22]">
              Why Carmie exists
            </p>
            <h2 className="max-w-3xl text-4xl font-black leading-[1.02] sm:text-5xl lg:text-6xl">
              Build the service layer local drivers already need.
            </h2>
          </div>
          <p className="max-w-2xl text-lg leading-8 text-[#4E5D50]">
            Carmie is not just another mechanic directory. The mission is to
            organize trusted automotive help across East African cities so
            drivers, garages, and towing providers can work from the same job
            record.
          </p>
        </div>

        <div className="grid gap-10 pt-12 lg:grid-cols-[minmax(0,0.85fr)_minmax(420px,1fr)]">
          <div className="grid gap-4">
            {principles.map((principle) => {
              const Icon = principle.icon;
              return (
                <div
                  key={principle.title}
                  className="grid grid-cols-[46px_minmax(0,1fr)] gap-4 border-l-2 border-[#8FE85E] bg-white px-5 py-5 shadow-sm"
                >
                  <div className="flex h-11 w-11 items-center justify-center rounded-md bg-[#111714] text-[#8FE85E]">
                    <Icon aria-hidden="true" />
                  </div>
                  <div>
                    <h3 className="text-xl font-black">{principle.title}</h3>
                    <p className="mt-2 leading-7 text-[#5D6B5F]">
                      {principle.text}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="relative">
            <div className="overflow-hidden rounded-md bg-[#111714] p-3 shadow-2xl">
              <img
                src={mechImg}
                alt="Carmie service partner inspecting a vehicle"
                className="h-[320px] w-full rounded object-cover object-center sm:h-[420px] lg:h-[460px]"
              />
            </div>
            <div className="mt-4 grid gap-3 sm:grid-cols-3">
              <div className="rounded-md bg-[#111714] p-4 text-white">
                <p className="text-xs font-black uppercase tracking-[0.14em] text-[#8FE85E]">
                  Drivers
                </p>
                <p className="mt-2 text-sm font-bold">Clear help request</p>
              </div>
              <div className="rounded-md bg-[#111714] p-4 text-white">
                <p className="text-xs font-black uppercase tracking-[0.14em] text-[#F4C44D]">
                  Providers
                </p>
                <p className="mt-2 text-sm font-bold">Structured job flow</p>
              </div>
              <div className="rounded-md bg-[#111714] p-4 text-white">
                <p className="text-xs font-black uppercase tracking-[0.14em] text-[#D6F7C6]">
                  Platform
                </p>
                <p className="mt-2 text-sm font-bold">Trusted service record</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
